<div class="row mb-4">
  <div class="d-flex align-items-center mb-3 mb-sm-0">
    <app-icon
      name="view-week"
      class="icon-bg bg-gray icon-blue ms-2"
    ></app-icon>
    <h6 class="m-0">
      {{ "LESSONS.WEEKLY_PLANNED_LESSONS" | translate }}
    </h6>
  </div>
</div>
<section class="card mb-5 accent-info px-3 py-4">
  <div class="d-flex justify-content-between">
    <div class="row ms-2 mb-4">
      <h3>{{ getScheduleName() }}</h3>
      <span class="text-muted small">
        {{ "LESSONS.ROOM_DETAILS.PLANNED_TO_START" | translate}}
        {{ getScheduleDatePlanned() }}
      </span>
    </div>
    <button
      type="button"
      class="btn btn-outline-primary question-mark-container rounded-pill px-2 mb-3"
      (click)="howToEnterModal.show()"
    >
      <app-icon name="question-mark" class="icon-blue"></app-icon>
    </button>
  </div>
  <div class="mx-2 bg-blue rounded-3 p-3 py-md-4 mb-4">
    <div class="d-flex flex-sm-row flex-column justify-content-sm-between">
      <div class="d-flex align-items-center mb-3 mb-sm-0">
        <div class="d-flex rounded-circle text-center bg-black me-2 initials-circle">
          <span class="text-muted m-auto">
            {{ getInitials(getTeacher()) }}
          </span>
        </div>
        <div class="my-auto">
          <p class="text-muted xsmall mb-0">
            {{ "LESSONS.ROOM_DETAILS.TEACHER" | translate }}
          </p>
          <p class="small mb-0">{{ getName(getTeacher()) }}</p>
        </div>
      </div>
      <div class="d-flex flex-column align-items-center">
        <button
          type="button"
          class="btn btn-primary rounded-pill mb-1 mb-sm-0 py-2 w-100"
          [disabled]="!getSelfLink()"
          (click)="enterRoom()"
        >
          {{ "COL.COURSES.COMING_LESSON.ENTER_ROOM" | translate }}
        </button>
        <button class="d-sm-none btn btn-outline-primary rounded-pill w-100"
          [disabled]="!getSelfLink()"
          (click)="copySelfLink()"
        >
          {{ getMobileCopyButtonText() | translate }}
        </button>
        <div
            id="copyTooltip"
            class="cursor-pointer d-none d-sm-block"
            data-bs-toggle="tooltip"
            data-bs-placement="bottom"
            data-bs-title=" "
            (click)="copySelfLink()"
          >
            <u>
              {{ "LESSONS.ROOM_DETAILS.OR_COPY_LINK" | translate }}
            </u>
        </div>
      </div>
    </div>
  </div>
  <div class="row mx-2 mb-4 pb-4 border-1 border-bottom border-secondary">
    <p>{{ "LESSONS.ROOM_DETAILS.REPORTED_TIMINGS" | translate }}</p>
    <div class="col-4">
      <p class="text-muted xsmall mb-0">
        {{ "LESSONS.ROOM_DETAILS.CLASSROOM_CREATED" | translate }}
      </p>
      <span class="small">{{ getScheduleDateCreated() }}</span>
    </div>
    <div class="col-4">
      <p class="text-muted xsmall mb-0">
        {{ "LESSONS.ROOM_DETAILS.PLANNED_TO_START" | translate }}:
      </p>
      <span class="small">{{ getScheduleDatePlanned() }}</span>
    </div>
    <div class="col-4">
      <p class="text-muted xsmall mb-0">
        {{ "LESSONS.ROOM_DETAILS.DURATION" | translate }}
      </p>
      <span class="small"
        >{{ getScheduleDuration() }}
        {{ "LESSONS.ROOM_DETAILS.MINUTES" | translate }}</span>
    </div>
  </div>
  <div *ngIf="getScheduleState()" class="row mx-2 mb-2">
    <p>{{ "LESSONS.ROOM_DETAILS.SYSTEM_DETAILS" | translate }}</p>
    <div class="col">
      <p class="text-muted xsmall mb-0">
        {{ "LESSONS.ROOM_DETAILS.STATUS" | translate }}
      </p>
      <span class="small">{{ getScheduleState() | translate }}</span>
    </div>
  </div>
</section>

<app-modal #howToEnterModal>
  <div class="modal-content top-0">
    <div class="modal-header border-0">
      <h5 class="modal-title">{{ "COL.LESSONS.HOW_TO_JOIN_LESSON.MODAL.TITLE" | translate }}</h5>
      <button type="button"
          class="btn btn-close btn-close-white"
          (click)="howToEnterModal.hide()"
          aria-label="Close">
      </button>
    </div>
    <div class="modal-body">
      <span class=" mb-2" [innerHTML]="htmlContent"></span>
    </div>
  </div>
</app-modal>
